export default __webpack_public_path__ + "assets/images/d2b56b67c64820100ec864a5bf6baacb.png";